'use strict';

require('timepicker');
require('jquery-ui/ui/widgets/datepicker');
require('jquery-ui/ui/i18n/datepicker-ja');
require('style-loader!css-loader!timepicker/jquery.timepicker.min.css');
require('style-loader!css-loader!jquery-ui/themes/base/base.css');
require('style-loader!css-loader!jquery-ui/themes/base/all.css');
require('style-loader!css-loader!jquery-ui/themes/base/datepicker.css');
require('common/ui/scss/module/_datepicker.scss');
require('backbone.stickit');
require('backbone-validation');
const _ = require('underscore');
const i18n = require('i18next');
const Moment = require('moment');
const Mn = require('backbone.marionette');
const Tooltip = require('common/ui/view/behavior/tooltip');
const Template = require('process/ui/template/action/date-edit.hbs');

const dateObserver = function(key) {
    return {
        observe: key,
        onGet: function(value) {
            const v = value ? Moment(value).local().format('L') : '';
            this.model.set(`${key}Date`, v);
            return v;
        },
        set: function(attr, value) {
            return this.model.set(`${key}Date`, value);
        }
    };
};

const timeObserver = function(key) {
    return {
        observe: key,
        onGet: function(value) {
            const v = value ? Moment(value).local().format('hh:mm a') : '';
            this.model.set(`${key}Time`, v);
            return v;
        },
        set: function(attr, value) {
            return this.model.set(`${key}Time`, value);
        }
    };
};

module.exports = Mn.View.extend({
    template: Template,
    ui: {
        startAt: '.start-at',
        startAtDate: '.start-at-date',
        startAtTime: '.start-at-time',
        startAtTodayButton: '.set-start-at-today',
        startAtClearButton: '.start-at-clear',
        startAtDateError: '.start-at-date-error',
        startAtTimeError: '.start-at-time-error',
        endAt: '.end-at',
        endAtDate: '.end-at-date',
        endAtTime: '.end-at-time',
        endAtTodayButton: '.set-end-at-today',
        endAtClearButton: '.end-at-clear',
        endAtDateError: '.end-at-date-error',
        endAtTimeError: '.end-at-time-error'
    },
    events: {
        'click @ui.startAtTodayButton': 'setStartAtToday',
        'click @ui.startAtClearButton': 'clearStartAt',
        'click @ui.endAtTodayButton': 'setEndAtToday',
        'click @ui.endAtClearButton': 'clearEndAt'
    },
    bindings: {
        '.start-at-date': dateObserver('startAt'),
        '.start-at-time': timeObserver('startAt'),
        '.end-at-date': dateObserver('endAt'),
        '.end-at-time': timeObserver('endAt')
    },
    behaviors: [Tooltip],

    initialize: function() {
        this.model = this.model.clone();
    },

    onRender: function() {
        this.listenTo(this.model, 'change:startAtDate',
            _.partial(this._validateDateTime, 'startAt'));
        this.listenTo(this.model, 'change:startAtTime',
            _.partial(this._validateDateTime, 'startAt'));
        this.listenTo(this.model, 'change:endAtDate',
            _.partial(this._validateDateTime, 'endAt'));
        this.listenTo(this.model, 'change:endAtTime',
            _.partial(this._validateDateTime, 'endAt'));

        this.listenTo(this.model, 'change:startAtDate',
            _.partial(this._setDefaultDates));
        this.listenTo(this.model, 'change:endAtDate',
            _.partial(this._setDefaultDates));

        Backbone.Validation.bind(this, {
            selector: 'class'
        });

        this.stickit();

        const project = this.getOption('project');
        const projectDefaultTime = project.getDefaultActionTime().toDate();
        if(i18n.default.language === 'en') {
            this.$('.start-at-date').datepicker($.datepicker.regional['en']);
        }else {
            this.$('.start-at-date').datepicker($.datepicker.regional['ja']);
        }
        this.$('.start-at-time').timepicker({
            timeFormat: 'G:i',
            scrollDefault: projectDefaultTime
        });
        this.ui.startAtDate.on('change', () => {
            if(!this.ui.startAtTime.val()) {
                this.$('.start-at-time').timepicker('setTime', projectDefaultTime);
                this.ui.startAtTime.trigger('input');
            }
            this.trigger('change:actionDate');
        });
        this.ui.startAtTime.on('change', () => {
            this.trigger('change:actionDate');
        });

        if(i18n.default.language === 'en') {
            this.$('.end-at-date').datepicker($.datepicker.regional['en']);
        }else {
            this.$('.end-at-date').datepicker($.datepicker.regional['ja']);
        }
        this.$('.end-at-time').timepicker({
            timeFormat: 'G:i',
            scrollDefault: projectDefaultTime
        });
        this.ui.endAtDate.on('change', () => {
            if(!this.ui.endAtTime.val()) {
                this.$('.end-at-time').timepicker('setTime', projectDefaultTime);
                this.ui.endAtTime.trigger('input');
            }
            this.trigger('change:actionDate');
        });
        this.ui.endAtTime.on('change', () => {
            this.trigger('change:actionDate');
        });

        this._setDefaultDates()

        return this;
    },

    validate: function() {
        if(!this._validateDateTime('startAt') || !this._validateDateTime('endAt')) {
            return false;
        }
        return true;
    },

    getJSON: function() {
        const json = {
            startAt: this.getStartAt(),
            endAt: this.getEndAt()
        };

        return json;
    },

    _validateDateTime: function(key) {
        const date = this.model.get(`${key}Date`);
        const time = this.model.get(`${key}Time`);
        const ui = this.ui[key];
        const dateErrorUI = this.ui[`${key}DateError`];
        const timeErrorUI = this.ui[`${key}TimeError`];
        ui.removeClass('has-error has-success');
        dateErrorUI.html('');
        timeErrorUI.html('');

        if(date && !time) {
            ui.addClass('has-error');
            timeErrorUI.html(i18n.t('process:action-setting.errors.time-required'));
            return false;
        }

        if(!date && time) {
            ui.addClass('has-error');
            dateErrorUI.html(i18n.t('process:action-setting.errors.date-required'));
            return false;
        }

        if(date && time) {
            let hasError = false;
            if(!Moment(date).isValid()) {
                dateErrorUI.html(i18n.t('process:action-setting.errors.date-invalid'));
                hasError = true;
            }
            if(!Moment(`2000/01/01 ${time}`).isValid()) {
                timeErrorUI.html(i18n.t('process:action-setting.errors.time-invalid'));
                hasError = true;
            }

            if(hasError) {
                ui.addClass('has-error');
                return false
            } else {
                ui.addClass('has-success');
                return true;
            }
        }

        return true;
    },

    _setDefaultDates: function() {
        const startDefaultDate = this.model.get('startAtDate') || this.model.get('endAtDate');
        this.$('.start-at-date').datepicker('option', 'defaultDate', startDefaultDate);
        const endDefaultDate = this.model.get('endAtDate') || this.model.get('startAtDate');
        this.$('.end-at-date').datepicker('option', 'defaultDate', endDefaultDate);
    },

    getStartAt: function() {
        const startAtDate = this.model.get('startAtDate');
        const startAtTime = this.model.get('startAtTime');

        if(startAtTime && startAtDate) {
            return Moment(startAtDate + ' ' + startAtTime);
        }
    },

    setStartAtToday: function() {
        const todayDate = this.getTodayDate();
        this.ui.startAtDate.val(todayDate);
        this.ui.startAtDate.trigger('change');
        this.model.set({startAtDate: todayDate});
        this.trigger('change:actionDate');
    },

    clearStartAt: function() {
        this.ui.startAtDate.val('');
        this.ui.startAtTime.val('');
        this.model.set({startAtDate: ''});
        this.model.set({startAtTime: ''});
        this.trigger('change:actionDate');
    },

    getEndAt: function() {
        const endAtDate = this.model.get('endAtDate');
        const endAtTime = this.model.get('endAtTime');

        if(endAtTime && endAtDate) {
            return Moment(endAtDate + ' ' + endAtTime);
        }
    },

    setEndAtToday: function() {
        const todayDate = this.getTodayDate();
        this.ui.endAtDate.val(todayDate);
        this.ui.endAtDate.trigger('change');
        this.model.set({endAtDate: todayDate});
        this.trigger('change:actionDate');
    },

    clearEndAt: function() {
        this.ui.endAtDate.val('');
        this.ui.endAtTime.val('');
        this.model.set({endAtDate: ''});
        this.model.set({endAtTime: ''});
        this.trigger('change:actionDate');
    },

    getTodayDate: function() {
        let todayDate;
        if(i18n.default.language === 'en') {
            todayDate = Moment().format('MM/DD/YYYY');
        } else {
            todayDate = Moment().format('YYYY/MM/DD');
        }
        return todayDate;
    }
});



// WEBPACK FOOTER //
// ./process/ui/view/action/date-edit.js